<template>
    <v-row class="ma-0 pa-0">
        <v-col class="pa-0">
            <search-date-picker :label="labelForStart"
                                :max="max"
                                :min="min"
                                :type="type"
                                @update:date="onDateStartChanged"
                                @update:innerDate="updateInnerDateStart"
                                ref="datePickerStart"
                                :disable="disable"
            />
        </v-col>
        <v-col class="pa-0 ml-3">
            <search-date-picker :label="labelForEnd"
                                :max="max"
                                :min="min"
                                :type="type"
                                @update:date="onDateEndChanged"
                                @update:innerDate="updateInnerDateEnd"
                                ref="datePickerEnd"
                                :disable="disable"
            />
        </v-col>
    </v-row>
</template>

<script>
    import SearchDatePicker from "./SearchDatePicker";
    import CoreDate from "./CoreDate";

    const BIAS_START = 'start';
    const BIAS_END = 'end';

    export default {
        name: "SearchDateRangePicker",
        mixins: [CoreDate],
        components: {SearchDatePicker},
        props: {
            range: Number,
            rangeBetween: Number,
            bias: String,
            start: null,
            end: null,
            min: null,
            max: null,
            labelForStart: {
                type: String,
                default() {
                    return this.$translate("시작일");
                },
            },
            labelForEnd: {
                type: String,
                default() {
                    return this.$translate("종료일");
                },
            },
            type: {
                type: String,
                default: 'date'
            },
            disable:{
                type: Boolean,
                default: false,
            }
        },

        data() {
            return {
                innerDateStart: null,
                innerDateEnd: null,
                innerDateEndOfEnd: null, // end of 데이터
                innerRange: 0,
            }
        },

        computed: {
            rangeBias() {
                switch (this.bias) {
                    case BIAS_START:
                    case BIAS_END:
                        return this.bias;
                    default:
                        return BIAS_END;
                }
            },
            rangeComputed() {
                return this.innerRange || 3;
            },
            innerType() {
                return this.type === 'month' ? 'month' : 'date';
            },
            endOfType() {
                return this.innerType === 'month' ? 'month' : 'day';
            },
        },

        watch: {
            range(newVal, oldVal){
                this.setRange(newVal) ;
            }
        },

        methods: {
            initializeDateStart() {
                switch (this.rangeBias) {
                    case BIAS_START:
                        if (this.rangeBetween) {
                            return this.goToMonthFromCurrent((this.rangeComputed * -1) + this.rangeBetween)
                        } else {
                            return this.$now();
                        }
                    case BIAS_END:
                        return this.goToMonthFromCurrent(this.rangeComputed * -1);
                }
            },

            initializeDateEnd() {
                switch (this.rangeBias) {
                    case BIAS_START:
                        return this.goToMonthFromCurrent(this.rangeComputed);
                    case BIAS_END:
                        if (this.rangeBetween) {
                            return this.goToMonthFromCurrent((this.rangeComputed * -1) + this.rangeBetween);
                        } else {
                            return this.$now();
                        }
                }
            },

            goToMonthFromCurrent(m) {
                return this.$now().plus({month: m});
            },

            onDateStartChanged(luxonDate) {
                if (this.innerDateStart === luxonDate) return;
                this.innerDateStart = luxonDate;
                this.innerRange = 0;
                this.notifyDateChanged();
            },

            onDateEndChanged(luxonDate) {
                if (this.innerDateEnd === luxonDate) return;
                this.innerDateEnd = luxonDate;
                this.innerDateEndOfEnd = this.endOfISO(luxonDate, this.endOfType);
                this.innerRange = 0;
                this.notifyDateChanged();
            },

            notifyDateChanged() {
                this.$emit('update:range', {
                    start: this.innerDateStart,
                    end: this.innerDateEndOfEnd,
                });
            },

            clear() {
                this.innerDateStart = null;
                this.innerDateEnd = null;
                this.$refs.datePickerStart.clear();
                this.$refs.datePickerEnd.clear();
            },

            setRange(range) {
                if (this.innerRange === range) return;
                this.innerRange = range;
                this.updateManual();
            },

            updateManual() {
                const tempDateStart = this.start ? this.$parseDate(this.start) : (this.innerRange ? this.initializeDateStart() : null);
                this.$refs.datePickerStart.updateInnerDate(tempDateStart); // ISO 변환을 위해 updateInnerDate 호출
                const tempDateEnd = this.end ? this.$parseDate(this.end) : (this.innerRange ? this.initializeDateEnd() : null);
                this.$refs.datePickerEnd.updateInnerDate(tempDateEnd); // ISO 변환을 위해 udpateInnerDate 호출
                this.notifyDateChanged();
            },

            updateInnerDateStart(innerDate) {
                this.innerDateStart = innerDate;
            },

            updateInnerDateEnd(innerDate) {
                this.innerDateEnd = innerDate;
                this.innerDateEndOfEnd = this.endOfISO(innerDate, this.endOfType);
            },
        },

        mounted() {
            this.updateManual();
        },

        created() {
            this.innerRange = this.range;
        },
    }
</script>

<style scoped>
</style>
